import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '@/store';
import $http from '@/http';

interface AppState {
  showMenuMask: boolean;
  tryOutDialog: boolean;
  userInfo: {
    jwt?: string;
    userName?: string;
    expireTime?: string;
    avatar?: string;
  };
}

export const selectShowMenuMask = (state: RootState) => state.app.showMenuMask;
export const selectTryOutDialog = (state: RootState) => state.app.tryOutDialog;
export const selectUserInfo = (state: RootState) => state.app.userInfo;

export const getSmsCode = createAsyncThunk('app/getSmsCode', (payload: GetSmsCodeParams) => {
  return $http.post('api/Home/SendRegisterSms', payload);
});

const initialState: AppState = {
  showMenuMask: false,
  tryOutDialog: false,
  userInfo: {},
} as AppState;

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setShowMenuMask(state, action: PayloadAction<boolean | undefined>) {
      if (action.payload === true || action.payload === false) {
        state.showMenuMask = action.payload;
      } else {
        state.showMenuMask = !state.showMenuMask;
      }
    },

    setTryOutDialog(state, action: PayloadAction<boolean | undefined>) {
      if (action.payload === true || action.payload === false) {
        state.tryOutDialog = action.payload;
      } else {
        state.tryOutDialog = !state.tryOutDialog;
      }
    },

    setUserInfo(state, action: PayloadAction<AppState['userInfo']>) {
      if (action.payload.jwt) {
        localStorage.setItem('userInfo', JSON.stringify(action.payload));
      } else {
        localStorage.removeItem('userInfo');
      }
      state.userInfo = action.payload;
    },
  },
});

export const { setShowMenuMask, setTryOutDialog, setUserInfo } = appSlice.actions;

export default appSlice.reducer;
